import { RefreshCcw } from 'lucide-react';
import * as React from 'react';
import { FlexDiv } from '../containers_v2/products/style';
import { PrimaryColor } from '../styles/global/css/Utils';
import { Translate } from '../styles/global/translate';
import OutlinedButton from './OutlinedButton';

export default function RefreshButton(props: { isLoading: boolean, onFilter: (obj: object) => void, disabled?: boolean, label?: string }) {

	function handleClick() {
		props.onFilter({ refresh: true });
	}

	return (
		<FlexDiv gap='6px' onClick={!props.isLoading && !props.disabled ? handleClick : undefined} cursor={props.disabled ? 'not-allowed' : 'pointer'}>
			<OutlinedButton disabled={props.isLoading || props.disabled} icon={<RefreshCcw color={PrimaryColor} />}>
				{props.label ?? <Translate id='refresh_data' />}
			</OutlinedButton>
		</FlexDiv>
	);
}
